var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.075 30.927a7.467 7.467 0 0 1 14.933 0h3.46C56.469 24.892 51.577 20 45.542 20c-6.035 0-10.927 4.892-10.927 10.927v4.147h-4.479L25 40.21v26.486l5.135 5.136h30.813l5.135-5.136V40.21l-5.135-5.136H38.075v-4.147ZM28.46 41.643v23.62l3.108 3.108h27.945l3.109-3.108v-23.62l-3.108-3.108H31.568l-3.108 3.108Zm17.08 17.546a5.736 5.736 0 1 0 0-11.472 5.736 5.736 0 0 0 0 11.472Zm0 3.46a9.197 9.197 0 1 0 0-18.393 9.197 9.197 0 0 0 0 18.394Z",
    fill: "currentColor"
  })));
};
export default SvgLock;